<template>
    <div>
         <!-- main-area -->
         <main class="fix">
                <!-- breadcrumb-area -->
                <section class="breadcrumb__area breadcrumb__bg">
                    <div class="bg-img position-absolute top-0 bottom-0 start-0 w-100 h-100 kantor-bg"></div>
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="breadcrumb__content">
                                    <h2 class="title">Video Kegiatan</h2>
                                    <nav aria-label="breadcrumb">
                                        <ol class="breadcrumb">
                                            <li class="breadcrumb-item"><a href="javascript:void(0);">Galeri</a></li>
                                            <li class="breadcrumb-item active" aria-current="page">Video Kegiatan</li>
                                        </ol>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="breadcrumb__shape">
                        <img src="assets/img/images/breadcrumb_shape01.png" alt="Apexa" class="dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape02.png" alt="Apexa" class="rightToLeft dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape03.png" alt="Apexa" class="dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape04.png" alt="Apexa" class="dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape05.png" alt="Apexa" class="alltuchtopdown dark-opacity" />
                    </div>
                </section>

                <!-- blog-post-area -->
            <section class="blog__post-area-four">
                <div class="container">
                    
                    <div class="row justify-content-center">
                        <div class="col-xl-4 col-lg-6 col-md-10" v-for="data in list_data" :key="data.id">
                            <div class="blog-post-item blog__post-three shine-animate-item">
                                <div class="blog-post-thumb blog__post-thumb-three position-relative">

                                    <!-- VIDEO THUMB -->
                                    <video class="w-100 ratio ratio-16x9"
                                        style="width:100%; aspect-ratio:16/9; object-fit:cover; cursor:pointer;"
                                        @click="showModal(data)"
                                        muted playsinline>
                                        <source :src="file_path + data.file" type="video/mp4">
                                    </video>

                                    <!-- TOMBOL PLAY IKON -->
                                    <button @click.prevent="showModal(data)"
                                        class="btn-play-overlay position-absolute top-50 start-50 translate-middle">
                                        <i class="fas fa-play fa-2x"></i>
                                    </button>

                                </div>

                                 <div class="blog-post-content blog__post-content-three">
                                    <h2 class="title">
                                        <a href="javascript:void(0);" @click="showModal(data)">
                                        {{ data.judul || 'Tanpa Judul' }}
                                        </a>
                                    </h2>
                                    <div class="blog-post-meta mb-20">
                                        <ul class="list-wrap">
                                        <li><i class="fas fa-calendar-alt"></i>{{ convert_tgl(data.createAt) }}</li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="pagination-wrap mt-40">
                        <nav aria-label="Page navigation example">
                            <ul class="pagination list-wrap">
                            <li class="page-item" :class="{ disabled: page_first === 1 }">
                                <a class="page-link" href="#" @click.prevent="btn_prev"><i class="fas fa-angle-double-left"></i></a>
                            </li>
                            <li
                                class="page-item"
                                v-for="page in page_last"
                                :key="page"
                                :class="{ active: page === page_first }"
                            >
                                <a class="page-link" href="#" @click.prevent="go_to_page(page)">{{ page }}</a>
                            </li>
                            <li class="page-item" :class="{ disabled: page_first === page_last }">
                                <a class="page-link" href="#" @click.prevent="btn_next"><i class="fas fa-angle-double-right"></i></a>
                            </li>
                            </ul>
                        </nav>
                    </div>

                </div>

                <div class="about__shape-wrap-four">
                    <img src="assets/img/images/h4_about_shape01.png" alt="">
                    <img src="assets/img/images/h4_about_shape02.png" alt="" data-parallax='{"x" : -80 , "y" : -80 }'>
                </div>
            </section>
                    <!-- about-area-end -->
                <!-- breadcrumb-area-end -->
               
                
            </main>
            <!-- main-area-end -->
    
    
    </div>

    <div class="modal fade" id="videoModal" tabindex="-1" aria-labelledby="videoModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="videoModalLabel">{{ form.judul }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Tutup"></button>
      </div>
      <div class="modal-body text-center">
        <video 
          :src="file_path + form.file" 
          controls 
          autoplay 
          style="width:100%; height:auto;"
        ></video>
        <p class="mt-3">{{ form.deskripsi }}</p>
      </div>
    </div>
  </div>
</div>

    </template>

    <script>

        export default {

            data() {
                return {
                    file_path: this.$store.state.URL_APP + "uploads/",
                    list_data: [],
                    page_first: 1,
                    page_last: 0,
                    cari_value: "",
                    uraian: "",
                    form : {
                        id : '',
                        judul : '',
                        deskripsi : '',
                        file : '',
                        unit_kerja : '',
                        status : '',
                        createBy : '',
                        createAt : '',
                    },
                }
            },
            methods: {

                showModal(data) {
                this.form = data;

                // trigger Bootstrap Modal (v5)
                // eslint-disable-next-line no-undef
                const modal = new bootstrap.Modal(document.getElementById('videoModal'));
                modal.show();
            },

            getView: function() {
                this.cek_load_data = true;
                fetch(this.$store.state.ADD_VIDEO + "view", {
                    method: "POST",
                    headers: {
                    "content-type": "application/json",
                    },
                    body: JSON.stringify({
                    data_ke: this.page_first,
                    cari_value: this.cari_value,
                    kategori: this.kategori,
                    })
                })
                .then(res => res.json())
                .then(res_data => {
                    this.list_data = res_data.data;
                    this.page_last = res_data.jml_data;
                    this.cek_load_data = false;
                });
            },
                    

            // ================== PAGINASI ====================
            alertku: function(type, title) {
            this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
            });
            },

            btn_prev() {
                if (this.page_first > 1) {
                    this.page_first--;
                    this.getView();
                }
                },
                btn_next() {
                if (this.page_first < this.page_last) {
                    this.page_first++;
                    this.getView();
                }
                },

                go_to_page(page) {
                    this.page_first = page;
                    this.getView(); // atau nama method Anda untuk fetch data
                },

            cari_data : function(){

                this.page_first = 1;
                this.getView();
            },
            onFileSelected: function(event) {
            this.form.file = event.target.files[0];
            },
            convert_tgl: function(dateString) {
            var date = new Date(dateString);
            return date.getDate() + "/" + date.getMonth() + "/" + date.getFullYear();
            }
            // ================== PAGINASI ====================
            },
            // =============================================================== METHODS =========================================================================

            mounted() {

            this.getView();


                
            }
            };



    </script>



